import { NavLink } from "react-router-dom";
import "../styles/LandingPage.css";
import habits from "../images/healthy-habit.svg";
import LandingPageHeader from "../components/LandingPageHeader";
import { ReactComponent as ArrowRight } from "../images/arrow-right.svg"; 

export default function LandingPage(){
    return (<main className="main landing-page">
         <LandingPageHeader />
        <header className="header">
            <div className="header-text-container">
                <h1 className="header-heading">Now build habits the fun way</h1>
                <p className="header-text">Achieve your long term goals with ezHabit completely <span className="highlight uppercase bold">free</span> of charge!</p>
                <NavLink to="/app" className="btn btn-fill header-btn"> Go to App <ArrowRight className="btn-icon"/> </NavLink>
            </div>
            <div className="header-image-container">
                <img className="header-image" src={habits} alt="a person considering different habits"/>
            </div>
        </header>
        <section className="section-one">

        </section>
    </main>);
}

